import React from "react";
import PropTypes from "prop-types";
import "./Checkbox.scss";

export class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checked
    };
  }

  render() {
    const {disabled, onChange, id, htmlFor, checked, checkboxLabel} = this.props;
    return (
      <div className="tds-checkbox form-check form-check-inline">
        <input className="form-check-input"
               type="checkbox"
               id={id}
               checked={checked}
               disabled={disabled}
               onChange={onChange}/>
        <label className="form-check-label" htmlFor={htmlFor}>{checkboxLabel}</label>
      </div>
    );
  }
};

Checkbox.propTypes = {
  checkBoxHeader: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  checkboxLabel: PropTypes.string,
  onChange: PropTypes.func,
};